export const createQuestion = /* GraphQL */ `
  mutation CreateQuestion($input: QuestionInsert!) {
    createQuestion(input: $input) {
      id
      createdAt
      updatedAt
    }
  }
`;
